/**
 * Fittingbox – essayage virtuel.
 * Intégration d'origine : HC (10 juil. 2024, Symmetry 7.2.1).
 * Portage Symmetry 8.3.2 : 15 sept. 2026 – code sorti de main.js / variant-picker.js
 * pour ne plus modifier les fichiers du thème lors des mises à jour.
 *
 * Chargement à la demande : 19 sept. 2026 (Claude).
 * Le SDK FitMix (≈ 5,6 Mo avec son moteur WebAssembly) n'est plus chargé à
 * l'ouverture de chaque page. Il est téléchargé :
 *   - au premier clic sur un bouton « Essayer » (l'essayage s'ouvre dès qu'il est prêt) ;
 *   - ou par anticipation, quand le visiteur survole / touche un bouton « Essayer ».
 * Les pages sans bouton « Essayer » ne téléchargent plus rien de Fittingbox.
 */
(function () {
  var FITMIX_API_KEY = 'TBVAcXitApiZPVH791yxdHbAc8AKzBwtCnjtv6Xn';
  var FITMIX_SDK_URL = 'https://vto-advanced-integration-api.fittingbox.com/index.js';
  var BUTTON_SELECTOR = '.hc-glass-view, .hc-colc-tryon';
  var LOADING_CLASS = 'hc-fb-loading';

  var state = 'idle'; // idle | loading | ready
  var pendingFrameId = null;

  function setLoading(isLoading) {
    document.documentElement.classList.toggle(LOADING_CLASS, isLoading);
  }

  function openVto(frameId) {
    window.fitmixInstance.setFrame(frameId);
    window.fitmixInstance.startVto('live');
  }

  function onReady() {
    state = 'ready';
    setLoading(false);
    console.log('VTO module is ready.');
    if (pendingFrameId) {
      var frameId = pendingFrameId;
      pendingFrameId = null;
      openVto(frameId);
    }
  }

  function onFailure(message) {
    state = 'idle';
    pendingFrameId = null;
    setLoading(false);
    console.warn('Fittingbox : ' + message);
  }

  function createWidget() {
    if (typeof window.FitMix === 'undefined') {
      onFailure('script FitMix non chargé.');
      return;
    }
    window.fitmixInstance = window.FitMix.createWidget('my-fitmix-container', {
      apiKey: FITMIX_API_KEY,
      popupIntegration: {
        centeredHorizontal: true,
        centeredVertical: true,
        width: '700px',
        height: '600px'
      }
    }, function () {
      // Différé : garantit que window.fitmixInstance est bien assigné.
      setTimeout(onReady, 0);
    });
  }

  // Télécharge le SDK et prépare le module (une seule fois).
  function warmUp() {
    if (state !== 'idle') return;
    state = 'loading';

    if (typeof window.FitMix !== 'undefined') {
      createWidget();
      return;
    }
    var script = document.createElement('script');
    script.src = FITMIX_SDK_URL;
    script.async = true;
    script.onload = createWidget;
    script.onerror = function () {
      script.remove();
      onFailure('échec du téléchargement du SDK FitMix.');
    };
    document.head.appendChild(script);
  }

  // Ouvre l'essayage pour une monture (appelé par les boutons « Essayer »).
  window.hcStartFittingbox = function (frameId) {
    if (state === 'ready' && window.fitmixInstance) {
      openVto(frameId);
      return;
    }
    pendingFrameId = frameId;
    setLoading(true);
    warmUp();
  };

  // Préchargement sur intention : survol (ordinateur) ou premier contact (mobile).
  function onIntent(evt) {
    var target = evt.target;
    if (target && target.closest && target.closest(BUTTON_SELECTOR)) warmUp();
  }
  document.addEventListener('pointerover', onIntent, { passive: true });
  document.addEventListener('touchstart', onIntent, { passive: true });

  // Affiche le bouton de la variante sélectionnée (événement natif du thème).
  document.addEventListener('on:variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    var scope = evt.target && evt.target.closest
      ? evt.target.closest('[id^="shopify-section-"], [data-section-id]')
      : null;
    if (!scope || !scope.querySelector('.hc-glass-view')) scope = document;

    scope.querySelectorAll('.hc-glass-view').forEach(function (el) {
      el.classList.remove('hc-glass-active');
    });
    if (variant) {
      var btn = scope.querySelector('.hc-var-' + variant.id);
      if (btn) btn.classList.add('hc-glass-active');
    }
  });
})();